module.exports = __webpack_public_path__ + "img/dryva-visual-design.e7ce93cb.png";